import { render, staticRenderFns } from "./FPotensiMarker.vue?vue&type=template&id=3944ffc2"
import script from "./FPotensiMarker.vue?vue&type=script&lang=js"
export * from "./FPotensiMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports